import { CatalogosProps } from "../interfaces/catalogos/CatalogosInterface";

export const catalogosList: CatalogosProps[] = [
    { id: '1', descripcion: 'Estatus', path: '/administracion/catalogos/estatus' },
    { id: '2', descripcion: 'Tipo de cubículo', path: '/administracion/catalogos/tipo-cubiculo' },
    { id: '3', descripcion: 'Tipo de sesión', path: '/administracion/catalogos/tipo-sesion' },
    { id: '4', descripcion: 'Tipo de usuario', path: '/administracion/catalogos/tipo-usuario' },
    { id: '5', descripcion: 'Unidad', path: '/administracion/catalogos/unidad' },
];
